import { DatasetPropertyResponse } from 'mapistry-shared';
import React, { useMemo } from 'react';
import styled from 'styled-components';
import {
  fillHeightAndScrollable,
  verticalLayout,
} from '../../../styles/layout';
import { Chip } from '../../Chip';
import { Table } from '../../Table/Table';
import { TableColumn } from '../../Table/types';

const Container = styled.div`
  ${verticalLayout}
`;

const StyledTable = styled(Table)`
  ${fillHeightAndScrollable}
` as typeof Table;

const StyledChip = styled(Chip)`
  margin-top: 0.25rem;
  margin-left: 0.5rem;
`;

const columns: TableColumn<DatasetPropertyResponse>[] = [
  {
    id: 'fullName',
    header: 'Field Name',
    contents: 'fullName',
  },
  {
    id: 'materializationColumnNames',
    header: 'Snowflake Columns',
    contents: (row: DatasetPropertyResponse) => (
      <>
        {row.materializationColumnNames.map((materializedColumnName) => (
          <StyledChip
            color="tertiary"
            key={materializedColumnName}
            label={materializedColumnName}
          />
        ))}
      </>
    ),
  },
];

type AnalyticsSyncTableProps = {
  datasetProperties: DatasetPropertyResponse[];
};

export function AnalyticsSyncTable({
  datasetProperties,
}: AnalyticsSyncTableProps) {
  const filteredProperties = useMemo(
    () =>
      datasetProperties.filter(
        (property) => !!property.materializationColumnNames.length,
      ),
    [datasetProperties],
  );

  return (
    <Container>
      <StyledTable
        ariaLabel="Fields to Snowflake columns mapping"
        columns={columns}
        rows={filteredProperties}
      />
    </Container>
  );
}
